<!--
Display Spinner on page on page load
-->
<app-page-spinner
  [active]="downloading"
  activeText="Loading..."
></app-page-spinner>
